import { useState } from "react";

import { ErrorProps, FormTextInput } from ".";

interface FormPasswordInputProps {
  autoFocus?: boolean;
  label: string;
  placeholder?: string;
  required?: boolean;
  errors?: ErrorProps;
  register: any;
  id?: string;
  autoComplete?: string;
}
export default function FormPasswordInput({
  autoFocus,
  label,
  required,
  errors,
  register,
  placeholder,
  id,
  autoComplete,
}: FormPasswordInputProps) {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  return (
    <FormTextInput
      id={id}
      autoComplete={autoComplete}
      label={label}
      required={required}
      errors={errors}
      autoFocus={autoFocus}
      placeholder={placeholder}
      register={register}
      type={showPassword ? "text" : "password"}
      suffix={showPassword ? "Eye" : "EyeOff"}
      onSuffixClick={() => setShowPassword(!showPassword)}
      suffixClass={errors?.error ? "text-destructive" : "text-neutral-400"}
    />
  );
}
